import { FC, useEffect } from 'react';
import classnames from 'classnames';
import { Toast as PulsarToast, type ToastProps as PulsarToastProps } from '@abtasty/design-system';
import styles from './toast.module.scss';

type ToastProps = PulsarToastProps & { delay?: number; open: boolean };

export const Toast: FC<ToastProps> = (props) => {
  const { delay = 3000, open } = props;
  if (!open) return null;

  let timeout;
  useEffect(() => {
    if (open) {
      timeout = setTimeout(() => {
        props.onDismissClick();
      }, delay);
    }
    return () => clearTimeout(timeout);
  }, [open]);

  return <PulsarToast {...props} className={classnames(props.className, styles.toast)} />;
};
